require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gi-bill-faq.json") })
        }
      }, "path---gi-bill-faq");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gi-bill-faq!./.cache/json/gi-bill-faq.json
// module id = 1228
// module chunks = 231608221292675